import { Injectable } from '@angular/core';
import {
  NavigationBehaviorOptions,
  NavigationEnd,
  NavigationExtras,
  Router,
  UrlCreationOptions,
  UrlTree,
} from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class A7Router {
  public previousUrl: string;
  public currentUrl: string;
  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
  }

  navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    // Debug weird re-directions by throw  exceptions & check frames
    // console.debug(commands);
    // if (commands[0] === '/u/portfolio') throw commands;
    return this.router.navigate(commands, extras);
  }

  navigateByUrl(
    url: string | UrlTree,
    extras?: NavigationBehaviorOptions,
  ): Promise<boolean> {
    return this.router.navigateByUrl(url, extras);
  }

  createUrlTree(
    commands: any[],
    navigationExtras?: UrlCreationOptions,
  ): UrlTree {
    return this.router.createUrlTree(commands, navigationExtras);
  }

  serializeUrl(url: UrlTree): string {
    return this.router.serializeUrl(url);
  }

  get url() {
    return this.router.url;
  }

  /**
   * Whether this app has a route of its own for `url` (a path, optionally
   * with query / fragment) — a `**` wildcard does not count. Two apps share
   * ark7.com (aurora at `/`, `/a`, `/aidc` …; the web app at `/u`,
   * `/setup-guide` …), so a same-host URL this app does not route belongs to
   * the other one and needs a full page load (Engineering #8).
   */
  routes(url: string): boolean {
    const segments = url.split(/[?#]/)[0].split('/').filter(Boolean);
    return this.router.config.some((route) => {
      if (route.matcher) {
        return true;
      }
      if (route.path == null || route.path === '**') {
        return false;
      }
      const own = route.path.split('/').filter(Boolean);
      if (own.length === 0) {
        // '' matches only the root unless it nests further routes.
        return route.pathMatch === 'full'
          ? segments.length === 0
          : !!(route.children || route.loadChildren);
      }
      return (
        own.every((s, i) =>
          s.startsWith(':') ? segments[i] != null : s === segments[i],
        ) &&
        (route.pathMatch !== 'full' || own.length === segments.length)
      );
    });
  }

  get events() {
    return this.router.events;
  }
}
